import { EntityResolverService } from '@schema-data-loader/core/resolver';

import { IOC } from '@/ioc/index';
import { Inversify } from '@/src/shared/utils/Inversify';


import type { IEntityResolver_Factory } from './entity-resolver.factory.types';
import type { CacheHeadersBuilder } from '../../../shared/domain/models/cache-headers-builder';
import type { AppLocale } from '@/src/shared/utils/i18n';
import type { IEntityResolverService } from '@schema-data-loader/core/resolver';



@Inversify.injectable('instance')
export default class EntityResolver_Factory implements IEntityResolver_Factory {
  private entityResolverHttpClientFactory = IOC.get('EntityResolverHttpClient_Factory');

  create(
    language: AppLocale,
    cacheHeadersBuilder: CacheHeadersBuilder | null
  ): IEntityResolverService {
    return new EntityResolverService(
      this.entityResolverHttpClientFactory.create(language, cacheHeadersBuilder)
    );
  }
}
